import React, { useState, useEffect } from 'react'
import './loginpage.css'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Grow from '@mui/material/Grow'
import { toast } from 'react-toastify'
//lottie
import Lottie from 'react-lottie-player'
import Loadanim from '../../assets/lottie/75839-jump-through-4-hoops.json'

//image
import Logo from '../../assets/ewb.png'

// firebase
import { primary } from '../../components/constants/colors'
import { useAuth } from '../Auth'

console.log('Login Runnign')
const LoginPage = () => {
  // const classes = useStyles()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const { login } = useAuth()

  // to clean the states
  useEffect(() => {
    console.log('Loading login page')

    //cleanup
    return () => {
      setEmail('')
      setPassword('')
      setLoading(false)
    }
  }, [])

  // login function
  const handleLogin = async () => {
    setLoading(true) //start loading
    try {
      await login(email, password)
      toast.success("You're logged in!", {
        position: toast.POSITION.TOP_CENTER, //position center
      })
    } catch (e) {
      toast.error('Incorrect credentials', {
        position: toast.POSITION.TOP_CENTER, //position center
      })
    }
    setLoading(false)
  }

  // callback function stores the token to session storage when it changes
  // useEffect(() => {
  //   if (token !== null) {
  //     sessionStorage.setItem("token", JSON.stringify(token));
  //   }
  // }, [token]);

  return (
    <div className="container">
      <Grid
        container
        spacing={3}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* small device full, beyond that half */}
        <Grid item xs={11} sm={4} style={{ marginTop: 150 }}>
          <Grow in timeout={1500}>
            <Paper elevation={3} style={{ padding: 50, textAlign: 'center' }}>
              {/* if loading, show lottie, else display form */}
              {loading === false ? (
                <>
                  <img
                    src={Logo}
                    alt="logo"
                    style={{ width: 200, alignSelf: 'center' }}
                  />
                  <form style={{ flexGrow: 1 }} noValidate autoComplete="off">
                    <h4>Login</h4>
                    <div style={{ flexDirection: 'column', display: 'flex' }}>
                      <TextField
                        id="1"
                        label="Email"
                        variant="outlined"
                        value={email}
                        placeholder="johndoe@example.com"
                        onChange={(text) => setEmail(text.target.value)}
                        style={{ margin: 10 }}
                      />
                      <TextField
                        id="2"
                        label="Password"
                        variant="outlined"
                        value={password}
                        onChange={(text) => setPassword(text.target.value)}
                        type="password"
                        style={{ margin: 10 }}
                      />
                    </div>
                  </form>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: primary, color: 'white' }}
                    onClick={handleLogin}
                  >
                    Login
                  </Button>
                </>
              ) : (
                <div className="lottieContainer">
                  <Lottie
                    loop
                    animationData={Loadanim}
                    play
                    style={{
                      width: 350,
                      height: 350,
                    }}
                  />
                </div>
              )}
            </Paper>
          </Grow>
        </Grid>
      </Grid>
    </div>
  )
}

export default LoginPage
